// src/hooks/useAuthApi.js
import useApi from "./useApi";

/**
 * Custom hook for authentication-related API calls
 */
export const useAuthApi = () => {
  const { api, loading, error, data } = useApi({
    showToast: true,
  });

  /**
   * User registration
   * @param {Object} userData - User registration data
   */
  const register = async (userData) => {
    return await api.post("/auth/v1/signup", userData, {
      showToast: true,
    });
  };

  /**
   * User login
   * @param {Object} credentials - Login credentials
   */
  const login = async (credentials) => {
    return await api.post("/auth/v1/login", credentials, {
      showToast: true,
    });
  };

  /**
   * Verify email
   * @param {string} token - Verification token
   */
  const verifyEmail = async (token) => {
    return await api.post(
      "/auth/verify-email",
      { token },
      {
        showToast: true,
      }
    );
  };

  /**
   * Forgot password
   * @param {string} email - User email
   */
  const forgotPassword = async (email) => {
    return await api.post(
      "/auth/forgot-password",
      { email },
      {
        showToast: true,
      }
    );
  };

  /**
   * Reset password
   * @param {Object} resetData - Reset password data
   */
  const resetPassword = async (resetData) => {
    return await api.post("/auth/reset-password", resetData, {
      showToast: true,
    });
  };

  return {
    register,
    login,
    verifyEmail,
    forgotPassword,
    resetPassword,
    loading,
    error,
    data,
  };
};

export default useAuthApi;
